<template>
    <section>
        <form method="post" @submit="onFormSubmit($event)">
            <!-- <input type="radio" name="gender" value="أخوكم" checked v-model="gender">
            <input type="radio" name="gender" value="أختكم" v-model="gender"> -->
            <input type="text" name="name" v-model="hisName" placeholder="الإسم">
            <!-- <input type="text" name="name" v-model="hisTitle" placeholder="المسمى الوظيفي"> -->
            <button>
                <router-link 
                    :to="{ name: 'Card', params: { name: hisName} }"
                    :class="{'able': hisTitle && hisName}">✏️</router-link>
                <!-- <router-link 
                    :to="{ name: 'Card', params: { name: hisName, title: hisTitle, gender} }"
                    :class="{'able': hisTitle && hisName}">✏️</router-link> -->
            </button>
        </form>
    </section>
</template>

<script>
export default {
    data() {
        return {
            hisName: '',
            hisTitle: '',
            gender: 'أخوكم'
        }
    },
    methods: {
        onFormSubmit(e) {

            e.preventDefault();

            if(this.hisName.length > 4) {

                this.$router.push({name:'Card', params: { name: this.hisName } })
                
            }


        }
    }
}
</script>

<style lang="sass">
    form
        font-family: 'Lemonada', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif
        -webkit-font-smoothing: antialiased
        -moz-osx-font-smoothing: grayscale
        width: 40vw
        max-width: 300px
        min-width: 270px
        margin: 20px auto 0
        text-align: center
        font-family: inherit
        position: relative
            
        input[type="radio"]
            width: 0
            height: 0
            cursor: pointer

            &[value="أخوكم"]::after
                content: '👨'
                position: absolute
                bottom: -58px
                left: 60%
                transform: translateX(-50%)
                font-size: 1.5em
                opacity: .8
                transition: transform .3s cubic-bezier(0.175, 0.885, 0.32, 1.275), opacity .2s cubic-bezier(0.175, 0.885, 0.32, 1.275)

            &[value="أختكم"]::after
                content: '👩'
                position: absolute
                bottom: -60px
                left: 45%
                transform: translateX(-50%)
                font-size: 1.5em
                opacity: .8
                transition: transform .2s ease

            &:checked
                
                &::after
                    transform: translateX(-50%) scale(1.5)
                    opacity: 1

        input
            font-family: inherit
            color: #fff
            direction: rtl
            width: 100%
            margin: 5px 0
            padding: 7px 15px 7px 55px
            border: 0
            border-radius: 30px
            background-color: rgba(255, 255, 255, .4)
            font-size: 1.3em
            outline: 0

            &::placeholder
                color: rgba(255, 255, 255, .7)
                font-size: .8em

            @media screen and (max-width: 475px)
                padding: 2px 10px 2px 50px
                font-size: 1em

        button
            position: absolute
            bottom: 8px
            left: 3px
            width: 50px
            height: 50px
            font-size: 1.5em
            line-height: 50px
            border-radius: 50%
            border: 0
            outline: 0
            background-color: #fff
            cursor: pointer

            @media screen and (max-width: 475px)
                width: 30px
                height: 30px
                font-size: 1em
                line-height: 30px

            a
                text-decoration: none
                display: block
                width: 100%
                height: 100%
                border-radius: 50%
                pointer-events: none

                &.able
                    pointer-events: auto

</style>
